// src/components/header/header.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_destructuring_empty(o) {
  if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
  return o;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment HeaderLinkActionFragment on HeaderLinkAction {\n    analytics {\n      linkName\n      referrerId\n    }\n    linkTarget\n    isRelative\n    resource {\n      __typename\n      ...HeaderLinkHttpURIFragment\n    }\n  }\n  fragment HeaderLinkHttpURIFragment on HttpURI {\n    value\n    relativePath\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment HeaderOpenVirtualAgentActionFragment on HeaderOpenVirtualAgentAction {\n    conversationProperties {\n      launchPoint\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    fallbackAction {\n      __typename\n      ... on HeaderLinkAction {\n        __typename\n        linkTarget\n        analytics {\n          linkName\n          referrerId\n        }\n        isRelative\n        resource {\n          ... on HttpURI {\n            value\n            relativePath\n          }\n        }\n      }\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment HeaderLocaleLinkActionFragment on HeaderLocaleLinkAction {\n    analytics {\n      linkName\n      referrerId\n    }\n    langid\n    locale\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment HeaderButtonFragment on HeaderButton {\n    __typename\n    buttonType\n    linkTarget\n    text\n    testId\n    headerAction {\n      __typename\n      ...HeaderLinkActionFragment\n    }\n  }\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment BSABannerFragment on HeaderBanner {\n    __typename\n    text\n    subText\n    button {\n      ...HeaderButtonFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment HeaderNavLinkFragment on HeaderNavLink {\n    __typename\n    icon {\n      __typename\n      id\n      description\n    }\n    text\n    newTabText\n    testId\n    headerAction {\n      __typename\n      ...HeaderLinkActionFragment\n      ...HeaderOpenVirtualAgentActionFragment\n      ...HeaderLocaleLinkActionFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment HeaderMenuLinkFragment on HeaderMenuLink {\n    __typename\n    icon {\n      __typename\n      id\n      description\n    }\n    text\n    newTabText\n    testId\n    headerAction {\n      __typename\n      ...HeaderLinkActionFragment\n      ...HeaderOpenVirtualAgentActionFragment\n      ...HeaderLocaleLinkActionFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment HeaderSeparatorFragment on HeaderSeparator {\n    __typename\n    type\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment HeaderDialogFragment on HeaderDialog {\n    __typename\n    id\n    icon {\n      __typename\n      id\n      description\n    }\n    iconPosition\n    text\n    items {\n      __typename\n      ...HeaderMenuLinkFragment\n      ...HeaderSeparatorFragment\n    }\n    trackingEvent\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment HeaderMenuIllustrationFragment on HeaderMenuIllustration {\n    __typename\n    illustration {\n      id\n      url\n      description\n    }\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment HeaderMenuImageFragment on Image {\n    __typename\n    url\n    description\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment HeaderMenuImagesFragment on HeaderMenuImages {\n    __typename\n    images {\n      __typename\n      ...HeaderMenuImageFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment HeaderSignInButtonFragment on HeaderSignInButton {\n    __typename\n    buttonType\n    linkTarget\n    text\n    testId\n    headerAction {\n      __typename\n      ...HeaderLinkActionFragment\n    }\n  }\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment HeaderSignOutMenuLinkFragment on HeaderSignOutMenuLink {\n    __typename\n    icon {\n      __typename\n      id\n      description\n    }\n    text\n    newTabText\n    testId\n    headerAction {\n      __typename\n      ...HeaderLinkActionFragment\n    }\n  }\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment HeaderSignUpButtonFragment on HeaderSignUpButton {\n    __typename\n    buttonType\n    linkTarget\n    text\n    testId\n    headerAction {\n      __typename\n      ...HeaderLinkActionFragment\n    }\n  }\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment HeaderTextFragment on HeaderText {\n    __typename\n    textType\n    text\n    subText\n    textSize\n  }\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment HeaderMenuFragment on HeaderMenu {\n    __typename\n    text\n    icon {\n      ...IconFragment\n    }\n    iconPosition\n    menuPosition\n    impressionAnalytics {\n      referrerId\n      linkName\n    }\n    triggerAnalytics {\n      referrerId\n      linkName\n    }\n    autoOpen\n    menuCookies {\n      name\n      value\n    }\n    menuState {\n      ... on HeaderNotificationCenterState {\n        __typename\n      }\n    }\n    items {\n      __typename\n      ...HeaderTextFragment\n      ...HeaderButtonFragment\n      ...HeaderDialogFragment\n      ...HeaderSignInButtonFragment\n      ...HeaderSignUpButtonFragment\n      ...HeaderMenuLinkFragment\n      ...HeaderSignOutMenuLinkFragment\n      ...HeaderSeparatorFragment\n      ...HeaderMenuIllustrationFragment\n      ...HeaderMenuImagesFragment\n      ... on HeaderPicker {\n        __typename\n        skipSsr\n      }\n      ... on NotificationCenter {\n        __typename\n        skipSsr\n      }\n      ... on CommunicationCenter {\n        __typename\n        skipSsr\n      }\n      ... on HeaderLoyaltyMemberStatus {\n        __typename\n        skipSsr\n      }\n      ... on HeaderMemberWallet {\n        __typename\n        skipSsr\n      }\n      ... on HeaderCreditCardAccountPlacement {\n        __typename\n        skipSsr\n      }\n      ... on HeaderLoyaltyAccountSummaryWidget {\n        __typename\n        skipSsr\n      }\n    }\n  }\n  fragment IconFragment on Icon {\n    __typename\n    id\n    description\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment HeaderSectionLanguageToggleFragment on HeaderSection {\n    __typename\n    alignment\n    sectionData {\n      ...HeaderNavLinkFragment\n      __typename\n    }\n  }\n\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment HeaderLogoFragment on HeaderLogo {\n    __typename\n    imgSrc {\n      description\n      url\n    }\n    action {\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment HeaderSectionLogosFragment on HeaderSection {\n    __typename\n    alignment\n    sectionData {\n      ...HeaderLogoFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment HeaderSectionNavigationFragment on HeaderSection {\n    __typename\n    alignment\n    sectionData {\n      ...HeaderNavLinkFragment\n      ...HeaderMenuFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment HeaderSectionSecondaryNavigationFragment on HeaderSection {\n    __typename\n    alignment\n    sectionData {\n      ...HeaderNavLinkFragment\n      ...HeaderMenuFragment\n      ... on HeaderPicker {\n        __typename\n        skipSsr\n      }\n      ... on NotificationCenter {\n        __typename\n        skipSsr\n      }\n      ... on CommunicationCenter {\n        __typename\n        skipSsr\n      }\n      ... on MobileAppDownloadButton {\n        __typename\n        skipSsr\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment SubHeaderButtonFragment on HeaderButton {\n    ...HeaderButtonFragment\n  }\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment SubHeaderLogoFragment on SubHeaderLogo {\n    __typename\n    text\n    imgSrc {\n      description\n      url\n    }\n    action {\n      resource {\n        ... on HttpURI {\n          value\n          relativePath\n        }\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n      useRelativePath\n    }\n  }\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment SubHeaderFragment on SubHeader {\n    __typename\n    text\n    logo {\n      ...SubHeaderLogoFragment\n    }\n    button {\n      ...SubHeaderButtonFragment\n    }\n    partnerLoyaltyPoints {\n      skipSsr\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  query GlobalHeaderQuery(\n    $context: ContextInput!\n    $viewSize: HeaderViewSize\n    $lineOfBusiness: GlobalNavigationLineOfBusiness\n    $layout: HeaderLayout\n    $marketing: HeaderMarketingInput\n    $minimal: Boolean = false\n    $theme: String\n  ) {\n    globalHeader(\n      context: $context\n      viewSize: $viewSize\n      lineOfBusiness: $lineOfBusiness\n      layout: $layout\n      marketing: $marketing\n      minimal: $minimal\n      theme: $theme\n    ) {\n      logos {\n        ...HeaderSectionLogosFragment\n      }\n      primaryNavigation @skip(if: $minimal) {\n        ...HeaderSectionNavigationFragment\n      }\n      secondaryNavigation @skip(if: $minimal) {\n        ...HeaderSectionSecondaryNavigationFragment\n      }\n      languageToggle @include(if: $minimal) {\n        ...HeaderSectionLanguageToggleFragment\n      }\n      bsaBanner {\n        ...BSABannerFragment\n      }\n      subHeader {\n        ...SubHeaderFragment\n      }\n      viewSize\n      inverseThemePrimaryRow\n      inverseThemeSecondaryRow\n      externalSharedUIComponents @skip(if: $minimal) {\n        ... on GoogleOneTap {\n          skipSsr\n        }\n      }\n      redDotState @client\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
import React30 from "react";
import { gql as gql26, useQuery } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { MobileAppDownloadButton } from "@shared-ui/customer-mobile-app-download-button";
import { NotificationCenter } from "@shared-ui/customer-notification-center";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { Picker, PickerTriggerPlacementType } from "@shared-ui/global-navigation-picker";
import { useLogger } from "@shared-ui/logger-context";
import { CommunicationCenterPreviewMenu } from "@shared-ui/retail-communication-center-preview-menu";
import { GoogleOneTap } from "@shared-ui/retail-identity-google-one-tap";
import { GlobalNavigationRow as GlobalNavigationRow2, GlobalNavigationSiteHeader as GlobalNavigationSiteHeader3 } from "uitk-react-global-navigation";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
// src/__generated__/types.ts
var GlobalNavigationLineOfBusiness = /* @__PURE__ */function (GlobalNavigationLineOfBusiness3) {
  GlobalNavigationLineOfBusiness3["ACTIVITY"] = "ACTIVITY";
  GlobalNavigationLineOfBusiness3["CAR"] = "CAR";
  GlobalNavigationLineOfBusiness3["CRUISE"] = "CRUISE";
  GlobalNavigationLineOfBusiness3["FLIGHT"] = "FLIGHT";
  GlobalNavigationLineOfBusiness3["HOTEL"] = "HOTEL";
  GlobalNavigationLineOfBusiness3["PACKAGE"] = "PACKAGE";
  GlobalNavigationLineOfBusiness3["UNKNOWN"] = "UNKNOWN";
  return GlobalNavigationLineOfBusiness3;
}(GlobalNavigationLineOfBusiness || {});
var HeaderLayout = /* @__PURE__ */function (HeaderLayout3) {
  HeaderLayout3["DEFAULT"] = "DEFAULT";
  HeaderLayout3["MINIMAL"] = "MINIMAL";
  HeaderLayout3["SIMPLIFIED"] = "SIMPLIFIED";
  return HeaderLayout3;
}(HeaderLayout || {});
// src/hooks/use-theme.tsx
import { useEffect, useState } from "react";
var DARK_THEME_ATTRIBUTE = "data-theme-dark";
var DARK_THEME = "dark";
var PREFERS_COLOR_SCHEME_DARK_MEDIA = "(prefers-color-scheme: dark)";
var useTheme = function () {
  var _useState = _sliced_to_array(useState(null), 2),
    theme = _useState[0],
    setTheme = _useState[1];
  useEffect(function () {
    var darkThemeEnabled = document.body.getAttribute(DARK_THEME_ATTRIBUTE);
    var matchMedia = function (event) {
      setTheme(event.matches && darkThemeEnabled ? DARK_THEME : null);
    };
    if (darkThemeEnabled && window.matchMedia(PREFERS_COLOR_SCHEME_DARK_MEDIA).matches) {
      setTheme(DARK_THEME);
    }
    window.matchMedia(PREFERS_COLOR_SCHEME_DARK_MEDIA).addEventListener("change", matchMedia);
    return function () {
      window.matchMedia(PREFERS_COLOR_SCHEME_DARK_MEDIA).removeEventListener("change", matchMedia);
    };
  }, []);
  return theme;
};
// src/hooks/use-window-size.tsx
import { useEffect as useEffect2, useState as useState2 } from "react";
import debounce from "lodash.debounce";
// src/utils/is-client-side.ts
function isClientSide() {
  return typeof window === "object";
}
// src/hooks/use-window-size.tsx
var DELAY = 200;
var useWindowSize = function () {
  var getWindowSize = function getWindowSize() {
    var size = {
      width: clientSide ? window.innerWidth : null,
      height: clientSide ? window.innerHeight : null
    };
    return size;
  };
  var clientSide = isClientSide();
  var _useState2 = _sliced_to_array(useState2(getWindowSize), 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect2(function () {
    if (!clientSide) {
      return;
    }
    var handleWindowResize = debounce(function () {
      setWindowSize(getWindowSize());
    }, DELAY);
    window.addEventListener("resize", handleWindowResize);
    return function () {
      return window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return windowSize;
};
// src/components/header/__private/__fragments/bsa-banner.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { GlobalNavigationSiteHeader } from "uitk-react-global-navigation";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
// src/components/header/__private/__fragments/components/header-button.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { useProvidedState } from "@shared-ui/provided-state-context";
// src/components/header/context/page-name-context.tsx
import React from "react";
var PageNameContext = React.createContext("Unknown");
var usePageName = function () {
  return React.useContext(PageNameContext);
};
// src/components/header/__private/__fragments/actions/header-link-action.tsx
import { gql } from "@apollo/client";
var __HeaderLinkActionFragment = gql(_templateObject());
var getHeaderLinkAction = function (data) {
  if (data === null || data === void 0 ? void 0 : data.resource) {
    var resource = data.resource;
    var rel = data.linkTarget === "_blank" ? "noopener" : "";
    if (data.isRelative && (resource === null || resource === void 0 ? void 0 : resource.relativePath)) {
      return {
        href: resource.relativePath,
        target: data.linkTarget,
        rel: rel
      };
    }
    if (!data.isRelative && (resource === null || resource === void 0 ? void 0 : resource.value)) {
      return {
        href: resource.value,
        target: data.linkTarget,
        rel: rel
      };
    }
  }
  return {};
};
// src/components/header/__private/__fragments/actions/header-open-virtual-agent-action.tsx
import { gql as gql2 } from "@apollo/client";
import { setConversationContext } from "@shared-ui/customer-virtual-agent-control";
var __HeaderOpenVirtualAgentActionFragment = gql2(_templateObject1());
var getHeaderOpenVirtualAgentAction = function (pageName, data, providedState) {
  var _providedState_virtualAgentControlState;
  if (providedState === null || providedState === void 0 ? void 0 : (_providedState_virtualAgentControlState = providedState.virtualAgentControlState) === null || _providedState_virtualAgentControlState === void 0 ? void 0 : _providedState_virtualAgentControlState.isInitialized) {
    return {
      onClick: function () {
        var _data_conversationProperties;
        setConversationContext({
          conversationProperties: {
            launchPoint: ((_data_conversationProperties = data.conversationProperties) === null || _data_conversationProperties === void 0 ? void 0 : _data_conversationProperties.launchPoint) || "HeaderDefaultLaunchPoint",
            pageName: pageName
          }
        });
      }
    };
  }
  if ((data === null || data === void 0 ? void 0 : data.fallbackAction) && data.fallbackAction.__typename === "HeaderLinkAction") {
    return getHeaderLinkAction(data.fallbackAction);
  }
  return {};
};
// src/components/header/__private/__fragments/actions/header-locale-link-action.tsx
import { gql as gql3 } from "@apollo/client";
import * as queryString from "query-string";
var __HeaderLocaleLinkActionFragment = gql3(_templateObject2());
var getHeaderLocaleLinkAction = function (data) {
  return {
    onClick: function () {
      var queryParams = queryString.parse(window.location.search);
      window.location.search = queryString.stringify(_object_spread({}, queryParams, {
        locale: data.locale
      }));
    }
  };
};
// src/components/header/__private/__fragments/actions/action-hooks.ts
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var useAction = function (pageName, data, providedState) {
  var _ref = data || {},
    __typename = _ref.__typename,
    analytics = _ref.analytics;
  var actionProps = {};
  var clickTracker = useClickTracker();
  if (analytics) {
    actionProps.onClickCapture = function () {
      return clickTracker(analytics.referrerId, analytics.linkName, false);
    };
  }
  switch (__typename) {
    case "HeaderLinkAction":
      return _object_spread({}, getHeaderLinkAction(data), actionProps);
    case "HeaderOpenVirtualAgentAction":
      return _object_spread({}, getHeaderOpenVirtualAgentAction(pageName, data, providedState), actionProps);
    case "HeaderLocaleLinkAction":
      return _object_spread({}, getHeaderLocaleLinkAction(data), actionProps);
    default:
      return {};
  }
};
// src/components/header/__private/__fragments/components/button.tsx
import React3 from "react";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
// src/components/header/context/inverse-theme-context.tsx
import React2 from "react";
var InverseThemeContext = React2.createContext(false);
var useInverseThemeContext = function () {
  return React2.useContext(InverseThemeContext);
};
// src/components/header/__private/__fragments/components/button.tsx
var Button = function (param) {
  var buttonType = param.buttonType,
    text = param.text,
    actionProps = param.actionProps,
    size = param.size,
    isFullWidth = param.isFullWidth;
  var useInverseTheme = useInverseThemeContext();
  var fullWidth = isFullWidth !== void 0 ? isFullWidth : true;
  if (!text || !actionProps) {
    return null;
  }
  return /* @__PURE__ */React3.createElement(React3.Fragment, null, buttonType === "PRIMARY" /* PRIMARY */ && /* @__PURE__ */React3.createElement(UitkPrimaryButton, _object_spread_props(_object_spread({
    isFullWidth: fullWidth
  }, actionProps), {
    size: size,
    inverse: useInverseTheme
  }), text), buttonType === "SECONDARY" /* SECONDARY */ && /* @__PURE__ */React3.createElement(UitkSecondaryButton, _object_spread_props(_object_spread({
    isFullWidth: fullWidth
  }, actionProps), {
    size: size,
    inverse: useInverseTheme
  }), text), buttonType === "TERTIARY" /* TERTIARY */ && /* @__PURE__ */React3.createElement(UitkTertiaryButton, _object_spread_props(_object_spread({
    isFullWidth: fullWidth
  }, actionProps), {
    size: size,
    inverse: useInverseTheme
  }), text));
};
// src/components/header/__private/__fragments/components/header-button.tsx
var fragment = gql4(_templateObject3(), __HeaderLinkActionFragment);
var HeaderButton = function (param) {
  var data = param.data,
    size = param.size,
    isFullWidth = param.isFullWidth;
  var testId = data.testId,
    headerAction = data.headerAction;
  var pageName = usePageName();
  var _useProvidedState = _sliced_to_array(useProvidedState(), 1),
    state = _useProvidedState[0];
  var actionProps = _extends({}, _object_destructuring_empty(useAction(pageName, headerAction, state)));
  return /* @__PURE__ */React4.createElement(Button, _object_spread_props(_object_spread({}, data), {
    actionProps: actionProps,
    "data-stid": testId,
    size: size,
    isFullWidth: isFullWidth
  }));
};
HeaderButton.displayName = "HeaderButton";
HeaderButton.fragment = _object_spread_props(_object_spread({}, fragment), {
  __typename: "HeaderButton"
});
// src/components/header/__private/__fragments/bsa-banner.tsx
var fragment2 = gql5(_templateObject4(), HeaderButton.fragment);
var BSABanner = function (props) {
  var data = props.data;
  var text = data.text,
    subText = data.subText,
    button = data.button;
  var useInverseTheme = useInverseThemeContext();
  return /* @__PURE__ */React5.createElement(GlobalNavigationSiteHeader, null, /* @__PURE__ */React5.createElement(UitkSpacing, {
    padding: {
      inline: "six",
      blockstart: "six",
      blockend: "two"
    }
  }, /* @__PURE__ */React5.createElement(UitkLayoutFlex, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React5.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React5.createElement("div", null, /* @__PURE__ */React5.createElement(UitkText, _object_spread({
    size: 300,
    weight: "medium"
  }, useInverseTheme && {
    theme: "inverse"
  }), text), /* @__PURE__ */React5.createElement(UitkText, _object_spread({
    size: 300,
    weight: "bold"
  }, useInverseTheme && {
    theme: "inverse"
  }), subText))), /* @__PURE__ */React5.createElement(UitkLayoutFlexItem, null, button && /* @__PURE__ */React5.createElement("div", null, /* @__PURE__ */React5.createElement(HeaderButton, {
    data: button
  }))))));
};
BSABanner.displayName = "BSABanner";
BSABanner.fragment = _object_spread_props(_object_spread({}, fragment2), {
  __typename: "HeaderBanner"
});
// src/components/header/__private/__fragments/header-section-language-toggle.tsx
import React21 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
// src/components/header/__private/__fragments/components/header-nav-link.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useExperiment } from "@shared-ui/experiment-context";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
import { UitkButtonSize as UitkButtonSize2, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var fragment3 = gql6(_templateObject5(), __HeaderLinkActionFragment, __HeaderOpenVirtualAgentActionFragment, __HeaderLocaleLinkActionFragment);
var HeaderNavLink = function (param) {
  var data = param.data;
  var icon = data.icon,
    text = data.text,
    headerAction = data.headerAction,
    testId = data.testId;
  var pageName = usePageName();
  var useInverseTheme = useInverseThemeContext();
  var _useProvidedState2 = _sliced_to_array(useProvidedState2(), 1),
    state = _useProvidedState2[0];
  var omitNavButtonClass = useExperiment("Shared_UI_Remove_Deprecated_UITK_Nav_Button").exposure.bucket > 0;
  var actionProps = _extends({}, _object_destructuring_empty(useAction(pageName, headerAction, state)));
  return /* @__PURE__ */React6.createElement(UitkLayoutFlexItem2, {
    key: text,
    grow: 0,
    minWidth: omitNavButtonClass ? void 0 : "zero"
  }, /* @__PURE__ */React6.createElement(UitkSpacing2, {
    margin: omitNavButtonClass ? {
      small: {
        inline: "one"
      },
      large: {
        inline: "two"
      }
    } : void 0
  }, /* @__PURE__ */React6.createElement(UitkTertiaryButton2, _object_spread_props(_object_spread({
    size: text ? UitkButtonSize2.MEDIUM : UitkButtonSize2.LARGE,
    className: omitNavButtonClass ? void 0 : "global-navigation-nav-button"
  }, actionProps), {
    "data-stid": testId,
    inverse: useInverseTheme
  }), [icon ? /* @__PURE__ */React6.createElement(UitkIcon, {
    key: "header-nav-link-icon",
    id: "header-nav-link-".concat(icon.id),
    name: icon.id,
    description: icon.description
  }) : null, text || null].filter(function (component) {
    return component !== null;
  }))));
};
HeaderNavLink.displayName = "HeaderNavLink";
HeaderNavLink.fragment = _object_spread_props(_object_spread({}, fragment3), {
  __typename: "HeaderNavLink"
});
// src/components/header/__private/__fragments/components/header-menu.tsx
import React20 from "react";
import { gql as gql17 } from "@apollo/client";
import { TertiaryButtonLargeIcon } from "@egds/react-lodging";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { LoyaltyMemberStatus } from "@shared-ui/global-navigation-loyalty";
import { MemberProfile } from "@shared-ui/global-navigation-member-profile";
import { MemberWallet } from "@shared-ui/global-navigation-member-wallet";
import { AccountPlacement, CreditCardAccountPlacementSourcePage, CreditCardAccountPlacementVariant } from "@shared-ui/retail-credit-card-account-placement";
import { LoyaltyAccountSummaryWidget, LoyaltyExperienceStrategy } from "@shared-ui/retail-loyalty-account-summary";
import { UitkFloatingDotNotificationBadge } from "uitk-react-badge";
import { UitkButtonSize as UitkButtonSize3 } from "uitk-react-button";
import { UitkIcon as UitkIcon3, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger, UitkMenuTriggerAnalyticsId } from "uitk-react-menu";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
// src/components/header/context/apollo-state-context.tsx
import React7 from "react";
var ApolloStateContext = React7.createContext("NOT_VISIBLE");
var useApolloState = function () {
  return React7.useContext(ApolloStateContext);
};
// src/components/header/__private/__fragments/components/conditional-render.tsx
import React8 from "react";
var ConditionalRender = function (props) {
  var shouldRender = props.shouldRender,
    children = props.children;
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, shouldRender && children);
};
// src/components/header/__private/__fragments/components/header-dialog.tsx
import React12 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/header/__private/__fragments/components/header-menu-link.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { useProvidedState as useProvidedState3 } from "@shared-ui/provided-state-context";
// src/components/header/__private/__fragments/components/menu-link.tsx
import React9 from "react";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var MenuLink = function (props) {
  var icon = props.icon,
    text = props.text,
    actionProps = props.actionProps,
    testId = props.testId,
    triggerRef = props.triggerRef;
  if (!text && !icon) {
    return null;
  }
  if (!actionProps.href) {
    actionProps.href = "#";
  }
  return /* @__PURE__ */React9.createElement(UitkLayoutFlexItem3, {
    key: text,
    grow: 0,
    minWidth: "zero"
  }, /* @__PURE__ */React9.createElement("div", {
    className: "uitk-list"
  }, /* @__PURE__ */React9.createElement(UitkLink, {
    className: "uitk-list-item"
  }, /* @__PURE__ */React9.createElement("a", _object_spread_props(_object_spread({
    role: actionProps.href ? "link" : "button",
    "aria-label": text,
    "data-stid": testId
  }, actionProps), {
    ref: triggerRef
  }), /* @__PURE__ */React9.createElement(UitkText2, {
    size: 300,
    theme: "standard"
  }, icon && /* @__PURE__ */React9.createElement(UitkSpacing3, {
    padding: {
      inlineend: "three"
    }
  }, /* @__PURE__ */React9.createElement(UitkIcon2, {
    id: "menu-link-".concat(icon.id),
    name: icon.id,
    description: icon.description
  })), text)))));
};
// src/components/header/__private/__fragments/components/header-menu-link.tsx
var fragment4 = gql7(_templateObject6(), __HeaderLinkActionFragment, __HeaderOpenVirtualAgentActionFragment, __HeaderLocaleLinkActionFragment);
var HeaderMenuLink = function (param) {
  var data = param.data;
  var text = data.text,
    newTabText = data.newTabText,
    icon = data.icon,
    headerAction = data.headerAction,
    testId = data.testId;
  var pageName = usePageName();
  var _useProvidedState3 = _sliced_to_array(useProvidedState3(), 1),
    state = _useProvidedState3[0];
  var actionProps = _extends({}, _object_destructuring_empty(useAction(pageName, headerAction, state)));
  return /* @__PURE__ */React10.createElement(MenuLink, {
    text: text,
    newTabText: newTabText,
    icon: icon,
    actionProps: actionProps,
    testId: testId
  });
};
HeaderMenuLink.displayName = "HeaderMenuLink";
HeaderMenuLink.fragment = _object_spread_props(_object_spread({}, fragment4), {
  __typename: "HeaderMenuLink"
});
// src/components/header/__private/__fragments/components/header-separator.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkSpacingHr } from "uitk-react-spacing";
var fragment5 = gql8(_templateObject7());
var HeaderSeparator = function (props) {
  var data = props.data;
  if (!data || !data.type) {
    return null;
  }
  return /* @__PURE__ */React11.createElement(React11.Fragment, null, data.type === "HORIZONTAL_RULE" && /* @__PURE__ */React11.createElement(UitkSpacingHr, null));
};
HeaderSeparator.displayName = "HeaderSeparator";
HeaderSeparator.fragment = _object_spread_props(_object_spread({}, fragment5), {
  __typename: "HeaderSeparator"
});
// src/components/header/__private/__fragments/components/header-dialog.tsx
var fragment6 = gql9(_templateObject8(), HeaderMenuLink.fragment, HeaderSeparator.fragment);
var menuFragmentTypes = [HeaderMenuLink, HeaderSeparator];
var HeaderDialog = function (props) {
  var _props_data = props.data,
    id = _props_data.id,
    text = _props_data.text,
    icon = _props_data.icon,
    items = _props_data.items,
    trackingEvent = _props_data.trackingEvent;
  var _useDialog = _sliced_to_array(useDialog(id), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var triggerRef = React12.useRef(null);
  var clickTracker = useClickTracker2();
  var actionProps = {
    onClick: function () {
      clickTracker(trackingEvent, "");
      dialogActions.toggleDialog();
    }
  };
  var handleDialogToolbarClick = React12.useCallback(function () {
    dialogActions.closeDialog();
  }, [dialogActions]);
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, /* @__PURE__ */React12.createElement(MenuLink, {
    text: text,
    newTabText: "",
    icon: icon,
    actionProps: actionProps,
    testId: id,
    triggerRef: triggerRef
  }), isDialogOpen && /* @__PURE__ */React12.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React12.createElement(DialogComponent, null, /* @__PURE__ */React12.createElement(Viewport, null, /* @__PURE__ */React12.createElement(ViewSmall, null, /* @__PURE__ */React12.createElement(UitkSheet, {
    ariaLabel: text,
    isVisible: true,
    returnFocusOnClose: true,
    type: "full",
    triggerRef: triggerRef
  }, /* @__PURE__ */React12.createElement(UitkToolbar, {
    toolbarTitle: text,
    key: "dialog-toolbar-".concat(id),
    navigationContent: {
      onClick: handleDialogToolbarClick,
      navIconLabel: "Close",
      navType: "close"
    }
  }), /* @__PURE__ */React12.createElement(UitkSheetContent, null, items.map(function (item, index) {
    if (!item) {
      return null;
    }
    var MenuElement = menuFragmentTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!MenuElement) {
      return null;
    }
    return /* @__PURE__ */React12.createElement(MenuElement, {
      key: "".concat(item.__typename, "-").concat(index),
      data: item
    });
  })))), /* @__PURE__ */React12.createElement(ViewLarge, null, /* @__PURE__ */React12.createElement(UitkSheet, {
    isVisible: true,
    returnFocusOnClose: true,
    type: "centered",
    centeredSheetSize: "small",
    triggerRef: triggerRef
  }, /* @__PURE__ */React12.createElement(UitkToolbar, {
    toolbarTitle: text,
    key: "dialog-toolbar-".concat(id),
    navigationContent: {
      onClick: handleDialogToolbarClick,
      navIconLabel: "Close",
      navType: "close"
    }
  }), /* @__PURE__ */React12.createElement(UitkSheetContent, null, items.map(function (item, index) {
    if (!item) {
      return null;
    }
    var MenuElement = menuFragmentTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!MenuElement) {
      return null;
    }
    return /* @__PURE__ */React12.createElement(MenuElement, {
      key: "".concat(item.__typename, "-").concat(index),
      data: item
    });
  }))))))));
};
HeaderDialog.displayName = "HeaderDialog";
HeaderDialog.fragment = _object_spread_props(_object_spread({}, fragment6), {
  __typename: "HeaderDialog"
});
// src/components/header/__private/__fragments/components/header-menu-illustration.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
var fragment7 = gql10(_templateObject9());
var HeaderMenuIllustration = function (props) {
  var _props_data = props.data,
    _props_data_illustration = _props_data.illustration,
    id = _props_data_illustration.id,
    url = _props_data_illustration.url,
    description = _props_data_illustration.description;
  return /* @__PURE__ */React13.createElement(UitkSpacing4, {
    padding: {
      blockstart: "six",
      blockend: "three"
    }
  }, /* @__PURE__ */React13.createElement("div", {
    "data-stid": id
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlex2, {
    justifyContent: "center"
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlexItem4, {
    maxWidth: "30x"
  }, /* @__PURE__ */React13.createElement(UitkIllustrations, {
    alt: description,
    url: url
  })))));
};
HeaderMenuIllustration.displayName = "HeaderMenuIllustration";
HeaderMenuIllustration.fragment = _object_spread_props(_object_spread({}, fragment7), {
  __typename: "HeaderMenuIllustration"
});
// src/components/header/__private/__fragments/components/header-menu-images.tsx
import React15 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
// src/components/header/__private/__fragments/components/header-menu-image.tsx
import React14 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var fragment8 = gql11(_templateObject10());
var HeaderMenuImage = function (param) {
  var data = param.data;
  var url = data.url,
    description = data.description;
  return /* @__PURE__ */React14.createElement(UitkMark, {
    url: url,
    description: description,
    size: UitkMarkSize.EXTRA_SMALL
  });
};
HeaderMenuImage.fragment = _object_spread_props(_object_spread({}, fragment8), {
  __typename: "Image"
});
HeaderMenuImage.displayName = "HeaderMenuImage";
// src/components/header/__private/__fragments/components/header-menu-images.tsx
var fragment9 = gql12(_templateObject11(), HeaderMenuImage.fragment);
var HeaderMenuImages = function (param) {
  var data = param.data;
  var images = data.images;
  return /* @__PURE__ */React15.createElement(UitkSpacing5, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React15.createElement(UitkLayoutFlex3, {
    space: "three",
    justifyContent: "center"
  }, images.map(function (image) {
    return /* @__PURE__ */React15.createElement(HeaderMenuImage, {
      key: image.description,
      data: image
    });
  })));
};
HeaderMenuImages.fragment = _object_spread_props(_object_spread({}, fragment9), {
  __typename: "HeaderMenuImages"
});
HeaderMenuImages.displayName = "HeaderMenuImages";
// src/components/header/__private/__fragments/components/header-sign-in-button.tsx
import React16 from "react";
import { gql as gql13 } from "@apollo/client";
import { useProvidedState as useProvidedState4 } from "@shared-ui/provided-state-context";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
// src/hooks/use-gss-redirect-url.tsx
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useBexApi } from "@shared-ui/bex-api-context";
var HOTWIRE = 30031;
var useGssRedirectUrl = function (baseUrl, hasAccount) {
  var _context_identity;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname,
    search = _useLocation.search,
    hash = _useLocation.hash;
  var context = useBexApi().context;
  var siteId = context === null || context === void 0 ? void 0 : context.siteId;
  var isAnonymous = (context === null || context === void 0 ? void 0 : (_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "ANONYMOUS";
  return useMemo(function () {
    var returnUrl = "".concat(pathname).concat(search).concat(hash);
    var returnUrlParams = siteId === HOTWIRE ? "&redirectUrl=targeturl=".concat(encodeURIComponent(returnUrl), "&referrerId=wl_prod") : "&uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(returnUrl)));
    var authUrl = baseUrl;
    if (!authUrl) {
      var hasAccountAction = isAnonymous ? "signin?" : "logout?";
      var action = hasAccount ? hasAccountAction : "createaccount?fromheader=true&";
      authUrl = "/user/".concat(action, "abax=14261.0&ckoflag=0");
    }
    return "".concat(authUrl).concat(authUrl.indexOf("?") !== -1 ? "" : "?").concat(returnUrlParams);
  }, [baseUrl, hasAccount, hash, isAnonymous, pathname, search, siteId]);
};
// src/components/header/__private/__fragments/components/header-sign-in-button.tsx
var fragment10 = gql13(_templateObject12(), __HeaderLinkActionFragment);
var HeaderSignInButton = function (param) {
  var data = param.data;
  var testId = data.testId,
    headerAction = data.headerAction;
  var pageName = usePageName();
  var _useProvidedState4 = _sliced_to_array(useProvidedState4(), 1),
    state = _useProvidedState4[0];
  var actionProps = _extends({}, _object_destructuring_empty(useAction(pageName, headerAction, state)));
  var urlWithRedirect = useGssRedirectUrl((actionProps === null || actionProps === void 0 ? void 0 : actionProps.href) || "", true);
  if ((actionProps === null || actionProps === void 0 ? void 0 : actionProps.href) && urlWithRedirect) {
    actionProps.href = urlWithRedirect;
  }
  return /* @__PURE__ */React16.createElement(UitkSpacing6, {
    margin: {
      inline: "six",
      blockend: "two"
    }
  }, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(Button, _object_spread_props(_object_spread({}, data), {
    actionProps: actionProps,
    "data-stid": testId
  }))));
};
HeaderSignInButton.displayName = "HeaderSignInButton";
HeaderSignInButton.fragment = _object_spread_props(_object_spread({}, fragment10), {
  __typename: "HeaderSignInButton"
});
// src/components/header/__private/__fragments/components/header-sign-out-menu-link.tsx
import React17 from "react";
import { gql as gql14 } from "@apollo/client";
import { useProvidedState as useProvidedState5 } from "@shared-ui/provided-state-context";
var fragment11 = gql14(_templateObject13(), __HeaderLinkActionFragment);
var HeaderSignOutMenuLink = function (param) {
  var data = param.data;
  var text = data.text,
    icon = data.icon,
    newTabText = data.newTabText,
    headerAction = data.headerAction,
    testId = data.testId;
  var pageName = usePageName();
  var _useProvidedState5 = _sliced_to_array(useProvidedState5(), 1),
    state = _useProvidedState5[0];
  var actionProps = _extends({}, _object_destructuring_empty(useAction(pageName, headerAction, state)));
  var urlWithRedirect = useGssRedirectUrl((actionProps === null || actionProps === void 0 ? void 0 : actionProps.href) || "", true);
  if ((actionProps === null || actionProps === void 0 ? void 0 : actionProps.href) && urlWithRedirect) {
    actionProps.href = urlWithRedirect;
  }
  return /* @__PURE__ */React17.createElement(MenuLink, {
    text: text,
    icon: icon,
    newTabText: newTabText,
    actionProps: actionProps,
    testId: testId
  });
};
HeaderSignOutMenuLink.displayName = "HeaderSignOutMenuLink";
HeaderSignOutMenuLink.fragment = _object_spread_props(_object_spread({}, fragment11), {
  __typename: "HeaderSignOutMenuLink"
});
// src/components/header/__private/__fragments/components/header-sign-up-button.tsx
import React18 from "react";
import { gql as gql15 } from "@apollo/client";
import { useProvidedState as useProvidedState6 } from "@shared-ui/provided-state-context";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
var fragment12 = gql15(_templateObject14(), __HeaderLinkActionFragment);
var HeaderSignUpButton = function (param) {
  var data = param.data;
  var testId = data.testId,
    headerAction = data.headerAction;
  var pageName = usePageName();
  var _useProvidedState6 = _sliced_to_array(useProvidedState6(), 1),
    state = _useProvidedState6[0];
  var actionProps = _extends({}, _object_destructuring_empty(useAction(pageName, headerAction, state)));
  var urlWithRedirect = useGssRedirectUrl((actionProps === null || actionProps === void 0 ? void 0 : actionProps.href) || "", true);
  if ((actionProps === null || actionProps === void 0 ? void 0 : actionProps.href) && urlWithRedirect) {
    actionProps.href = urlWithRedirect;
  }
  return /* @__PURE__ */React18.createElement(UitkSpacing7, {
    margin: {
      inline: "six",
      blockend: "six"
    }
  }, /* @__PURE__ */React18.createElement("div", null, /* @__PURE__ */React18.createElement(Button, _object_spread_props(_object_spread({}, data), {
    actionProps: actionProps,
    "data-stid": testId
  }))));
};
HeaderSignUpButton.displayName = "HeaderSignUpButton";
HeaderSignUpButton.fragment = _object_spread_props(_object_spread({}, fragment12), {
  __typename: "HeaderSignUpButton"
});
// src/components/header/__private/__fragments/components/header-text.tsx
import React19 from "react";
import { gql as gql16 } from "@apollo/client";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading, UitkSubheading, UitkText as UitkText3 } from "uitk-react-text";
var fragment13 = gql16(_templateObject15());
var _obj;
var headerTextSizeMapper = (_obj = {}, _define_property(_obj, "SMALL" /* SMALL */, 5), _define_property(_obj, "LARGE" /* LARGE */, 4), _obj);
var HeaderText = function (props) {
  var _props_data = props.data,
    textType = _props_data.textType,
    text = _props_data.text,
    subText = _props_data.subText,
    textSize = _props_data.textSize;
  var useInverseTheme = useInverseThemeContext();
  if (!text) {
    return null;
  }
  var defaultHeaderText = /* @__PURE__ */React19.createElement(UitkSpacing8, {
    padding: {
      blockstart: "three",
      blockend: "six",
      inline: "six"
    }
  }, /* @__PURE__ */React19.createElement(UitkLayoutFlex4, {
    alignItems: "start",
    direction: "column",
    space: "one"
  }, textType === "HEADING" && /* @__PURE__ */React19.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */React19.createElement(UitkHeading, {
    tag: "h2",
    size: 5
  }, text)), textType === "HEADING" && subText && /* @__PURE__ */React19.createElement(UitkLayoutFlexItem5, {
    grow: 0
  }, /* @__PURE__ */React19.createElement(UitkSubheading, null, subText))));
  var oneKeyHeaderText = /* @__PURE__ */React19.createElement(UitkSpacing8, {
    padding: {
      blockstart: "three",
      blockend: "six",
      inline: "six"
    }
  }, /* @__PURE__ */React19.createElement(UitkLayoutFlex4, {
    alignItems: "center",
    direction: "column",
    space: "four"
  }, textType === "HEADING" && /* @__PURE__ */React19.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */React19.createElement(UitkSpacing8, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React19.createElement(UitkHeading, {
    tag: "h4",
    size: headerTextSizeMapper[textSize !== null && textSize !== void 0 ? textSize : "SMALL" /* SMALL */],
    align: "center"
  }, text))), textType === "HEADING" && subText && /* @__PURE__ */React19.createElement(UitkLayoutFlexItem5, {
    grow: 0
  }, /* @__PURE__ */React19.createElement(UitkText3, _object_spread({
    align: "center",
    weight: "medium",
    size: 500
  }, useInverseTheme && {
    theme: "inverse"
  }), subText))));
  return /* @__PURE__ */React19.createElement(Experiment, {
    name: "GlobalNav_OneKey_FeatureGate"
  }, /* @__PURE__ */React19.createElement(ExperimentControl, null, defaultHeaderText), /* @__PURE__ */React19.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React19.createElement(Experiment, {
    name: "GlobalNav_IsOneKey_Sites"
  }, /* @__PURE__ */React19.createElement(ExperimentControl, null, defaultHeaderText), /* @__PURE__ */React19.createElement(ExperimentVariant, {
    bucket: 1
  }, oneKeyHeaderText))));
};
HeaderText.displayName = "HeaderText";
HeaderText.fragment = _object_spread_props(_object_spread({}, fragment13), {
  __typename: "HeaderText"
});
// src/components/header/__private/__fragments/components/header-menu.tsx
var fragment14 = gql17(_templateObject16(), HeaderText.fragment, HeaderButton.fragment, HeaderDialog.fragment, HeaderSignInButton.fragment, HeaderSignUpButton.fragment, HeaderMenuLink.fragment, HeaderSignOutMenuLink.fragment, HeaderSeparator.fragment, HeaderMenuIllustration.fragment, HeaderMenuImages.fragment);
var menuFragmentTypes2 = [HeaderText, HeaderButton, HeaderMenuImages, HeaderDialog, HeaderSignInButton, HeaderSignUpButton, HeaderMenuLink, HeaderSignOutMenuLink, HeaderSeparator, HeaderMenuIllustration];
var getMemberProfileComponent = function (context, setLoading, memberTierCelebrationBucketed, oneKeyBexMemberCelebrationBucketed, bexUKMemberCelebrationBucketed, icon) {
  var _context_identity;
  var hasTnL = memberTierCelebrationBucketed || oneKeyBexMemberCelebrationBucketed || bexUKMemberCelebrationBucketed;
  var _icon_description;
  var iconComponent = icon ? /* @__PURE__ */React20.createElement(UitkIcon3, {
    key: "trigger-icon",
    id: "header-menu-".concat(icon.id),
    name: icon.id,
    description: (_icon_description = icon === null || icon === void 0 ? void 0 : icon.description) !== null && _icon_description !== void 0 ? _icon_description : ""
  }) : null;
  if (((_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "ANONYMOUS" /* ANONYMOUS */ || !hasTnL) {
    return iconComponent;
  }
  if (hasTnL) {
    return /* @__PURE__ */React20.createElement(MemberProfile, {
      setLoading: setLoading,
      skipSsr: true,
      inputs: {}
    });
  }
  return null;
};
var getHeaderMenuContainerSharedUIComponents = function (displayName, key, opened, egCobrandCreditCardWebSwitchBucketed) {
  var headerMenuContainerSharedUIComponents = /* @__PURE__ */new Map([["HeaderLoyaltyAccountSummaryWidget", /* @__PURE__ */React20.createElement(ConditionalRender, {
    key: key,
    shouldRender: opened
  }, /* @__PURE__ */React20.createElement(UitkSpacing9, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(LoyaltyAccountSummaryWidget, {
    inputs: {
      strategy: LoyaltyExperienceStrategy.SHOW_TRAVELER_INFO_AND_REWARDS_LINK,
      viewId: "HeaderView"
    }
  }))))], ["HeaderMemberWallet", /* @__PURE__ */React20.createElement(ConditionalRender, {
    key: key,
    shouldRender: opened
  }, /* @__PURE__ */React20.createElement(MemberWallet, {
    skipSsr: true
  }))], ["HeaderCreditCardAccountPlacement", /* @__PURE__ */React20.createElement(ConditionalRender, {
    key: key,
    shouldRender: opened && egCobrandCreditCardWebSwitchBucketed
  }, /* @__PURE__ */React20.createElement(UitkSpacing9, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(AccountPlacement, {
    skipSsr: true,
    inputs: {
      variant: CreditCardAccountPlacementVariant.SMALL,
      sourcePage: CreditCardAccountPlacementSourcePage.GLOBAL_NAV
    }
  }))))], ["HeaderLoyaltyMemberStatus", /* @__PURE__ */React20.createElement(ConditionalRender, {
    key: key,
    shouldRender: opened
  }, /* @__PURE__ */React20.createElement(LoyaltyMemberStatus, {
    skipSsr: true
  }))]]);
  return headerMenuContainerSharedUIComponents.get(displayName);
};
var HeaderMenu = function (props) {
  var _context_identity, _context_identity1;
  var _props_data = props.data,
    text = _props_data.text,
    icon = _props_data.icon,
    iconPosition = _props_data.iconPosition,
    items = _props_data.items,
    menuPosition = _props_data.menuPosition,
    autoOpen = _props_data.autoOpen,
    menuCookies = _props_data.menuCookies,
    menuState = _props_data.menuState,
    triggerAnalytics = _props_data.triggerAnalytics,
    impressionAnalytics = _props_data.impressionAnalytics,
    componentsMap = props.componentsMap;
  var context = useBexApi2().context;
  var redDotState = useApolloState();
  var clickTracker = useClickTracker3();
  var _useExperiment2 = useExperiment2("Member_Tier_Celebration_on_Nav_Bar_Web"),
    memberTierCelebrationExposure = _useExperiment2.exposure;
  var _useExperiment21 = useExperiment2("EG_Cobrand_Credit_Card_Web_Switch"),
    egCobrandCreditCardWebSwitch = _useExperiment21.exposure;
  var _useExperiment22 = useExperiment2("OneKey_BEX_US_Member_Celebration_on_Nav_Bar_Web_", context.siteId === 1),
    oneKeyBexMemberCelebrationExposure = _useExperiment22.exposure;
  var _useExperiment23 = useExperiment2("BEX_UK_POSa_Member_Celebration_on_Nav_Bar_Web", context.siteId === 3),
    bexUKMemberCelebrationExposure = _useExperiment23.exposure;
  var omitNavButtonClass = useExperiment2("Shared_UI_Remove_Deprecated_UITK_Nav_Button").exposure.bucket > 0;
  var memberTierCelebrationBucketed = memberTierCelebrationExposure.bucket === 1;
  var egCobrandCreditCardWebSwitchBucketed = egCobrandCreditCardWebSwitch.bucket === 1;
  var oneKeyBexMemberCelebrationBucketed = oneKeyBexMemberCelebrationExposure.bucket === 1;
  var bexUKMemberCelebrationBucketed = bexUKMemberCelebrationExposure.bucket === 1;
  var anyMemberProfileExperimentBucketed = memberTierCelebrationBucketed || oneKeyBexMemberCelebrationBucketed || bexUKMemberCelebrationBucketed;
  var hideTextForMemberProfile = anyMemberProfileExperimentBucketed && (((_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "AUTHENTICATED" /* AUTHENTICATED */ || ((_context_identity1 = context.identity) === null || _context_identity1 === void 0 ? void 0 : _context_identity1.authState) === "IDENTIFIED" /* IDENTIFIED */);
  var useMemberProfileStyle = anyMemberProfileExperimentBucketed && iconPosition === "LEFT";
  var useInverseTheme = useInverseThemeContext();
  var _React20_useState = _sliced_to_array(React20.useState(autoOpen), 2),
    opened = _React20_useState[0],
    setOpened = _React20_useState[1];
  var _React20_useState1 = _sliced_to_array(React20.useState(autoOpen), 2),
    open = _React20_useState1[0],
    setOpen = _React20_useState1[1];
  var _React20_useState2 = _sliced_to_array(React20.useState(false), 2),
    loading = _React20_useState2[0],
    setLoading = _React20_useState2[1];
  React20.useEffect(function () {
    menuCookies === null || menuCookies === void 0 ? void 0 : menuCookies.forEach(function (cookie) {
      document.cookie = "".concat(cookie.name, "=").concat(cookie.value, "; path=/;");
    });
  }, [menuCookies]);
  var onTriggerClick = function () {
    if (!opened && !open && !loading) {
      setOpened(true);
    }
    setOpen(!open);
    if (!open && redDotState === "VISIBLE" /* VISIBLE */ && (menuState === null || menuState === void 0 ? void 0 : menuState.__typename) === "HeaderNotificationCenterState") {
      clickTracker("Web.Notification.NC.Header.Open.isUnseenIndicatorExist", "notification center unseen tracking");
    }
  };
  var tertiaryButtonClassName = omitNavButtonClass ? void 0 : "global-navigation-nav-button";
  if (redDotState === "VISIBLE" /* VISIBLE */ && (menuState === null || menuState === void 0 ? void 0 : menuState.__typename) === "HeaderNotificationCenterState") {
    tertiaryButtonClassName += " uitk-button-only-icon";
  }
  if (useMemberProfileStyle && loading) {
    return /* @__PURE__ */React20.createElement(MemberProfile, {
      setLoading: setLoading,
      skipSsr: true,
      inputs: {}
    });
  }
  var buttonText = text && (icon === null || icon === void 0 ? void 0 : icon.description) ? /* @__PURE__ */React20.createElement("div", {
    "aria-hidden": "true"
  }, text) : text;
  var flexMinWidth = useMemberProfileStyle ? "quarter_width" : "zero";
  if (omitNavButtonClass) {
    flexMinWidth = void 0;
  }
  var referrerMenuAction = open ? UitkMenuTriggerAnalyticsId.COLLAPSE : UitkMenuTriggerAnalyticsId.EXPAND;
  var _icon_description, _icon_description1, _icon_description2;
  return /* @__PURE__ */React20.createElement(UitkLayoutFlexItem6, {
    minWidth: flexMinWidth,
    key: text,
    grow: 0
  }, /* @__PURE__ */React20.createElement(UitkMenu, {
    isOpen: open,
    onTriggerClick: onTriggerClick
  }, /* @__PURE__ */React20.createElement(UitkMenuTrigger, {
    disableLocalAnalytics: !!impressionAnalytics
  }, /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(UitkSpacing9, {
    margin: omitNavButtonClass && text ? {
      small: {
        inline: "one"
      },
      large: {
        inline: "two"
      }
    } : void 0
  }, /* @__PURE__ */React20.createElement(TertiaryButtonLargeIcon, {
    title: (_icon_description = icon === null || icon === void 0 ? void 0 : icon.description) !== null && _icon_description !== void 0 ? _icon_description : "",
    size: text ? UitkButtonSize3.MEDIUM : UitkButtonSize3.LARGE,
    className: tertiaryButtonClassName,
    tabIndex: 0,
    analytics: (triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.referrerId) ? {
      id: triggerAnalytics.referrerId ? "".concat(triggerAnalytics.referrerId, ".").concat(referrerMenuAction) : "Header.Menu",
      description: "Header Menu Item",
      callback: function (rfrr, menuTriggerLinkName) {
        return clickTracker(rfrr, menuTriggerLinkName);
      }
    } : void 0,
    largeIcon: iconPosition === "LEFT",
    inverse: useInverseTheme,
    "data-testid": "header-menu-button"
  }, iconPosition === "RIGHT" ? [buttonText || null,
  // eslint-disable-next-line no-nested-ternary
  icon ? redDotState === "VISIBLE" /* VISIBLE */ && (menuState === null || menuState === void 0 ? void 0 : menuState.__typename) === "HeaderNotificationCenterState" ? /* @__PURE__ */React20.createElement(UitkLayoutPosition, {
    display: "inline-block",
    type: "relative"
  }, /* @__PURE__ */React20.createElement(UitkIcon3, {
    key: "trigger-icon",
    id: "header-menu-".concat(icon.id),
    name: icon.id,
    description: (_icon_description1 = icon === null || icon === void 0 ? void 0 : icon.description) !== null && _icon_description1 !== void 0 ? _icon_description1 : "",
    size: UitkIconSize.SMALL
  }), /* @__PURE__ */React20.createElement(UitkLayoutPosition, {
    cloneElement: true,
    type: "absolute",
    position: {
      right: "zero",
      top: "zero"
    }
  }, /* @__PURE__ */React20.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: "CommunicationCenter.MainNav.Impressions.isUnseenIndicatorExist",
    linkName: "CommunicationCenter Main Nav Unseen Impression"
  }, /* @__PURE__ */React20.createElement(UitkFloatingDotNotificationBadge, {
    visible: true
  })))) : /* @__PURE__ */React20.createElement(UitkIcon3, {
    key: "trigger-icon",
    id: "header-menu-".concat(icon.id),
    name: icon.id,
    description: (_icon_description2 = icon === null || icon === void 0 ? void 0 : icon.description) !== null && _icon_description2 !== void 0 ? _icon_description2 : "",
    size: UitkIconSize.SMALL
  }) : null].filter(function (component) {
    return component !== null;
  }) : [/* @__PURE__ */React20.createElement(UitkLayoutPosition, {
    key: "member-profile",
    display: "inline-block",
    type: "relative"
  }, getMemberProfileComponent(context, setLoading, memberTierCelebrationBucketed, oneKeyBexMemberCelebrationBucketed, bexUKMemberCelebrationBucketed, icon !== null && icon !== void 0 ? icon : void 0), redDotState === "VISIBLE" /* VISIBLE */ && (menuState === null || menuState === void 0 ? void 0 : menuState.__typename) === "HeaderNotificationCenterState" && /* @__PURE__ */React20.createElement(UitkLayoutPosition, {
    cloneElement: true,
    type: "absolute",
    position: {
      right: "zero",
      top: "zero"
    }
  }, /* @__PURE__ */React20.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: "CommunicationCenter.MainNav.Impressions.isUnseenIndicatorExist",
    linkName: "CommunicationCenter Main Nav Unseen Impression"
  }, /* @__PURE__ */React20.createElement(UitkFloatingDotNotificationBadge, {
    visible: true
  })))), !hideTextForMemberProfile && buttonText || null].filter(function (component) {
    return component !== null;
  }))))), /* @__PURE__ */React20.createElement(UitkMenuContainer, {
    width: 375,
    position: menuPosition === "LEFT" ? PositionType.LEFT : PositionType.RIGHT,
    intersectionObserverRoot: "body",
    autoPosition: true
  }, /* @__PURE__ */React20.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) || "Header.Menu",
    linkName: (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || ""
  }, /* @__PURE__ */React20.createElement(InverseThemeContext.Provider, {
    value: false
  }, /* @__PURE__ */React20.createElement("div", null, items.map(function (item, index) {
    if (!item) {
      return null;
    }
    var SharedUIComponent = componentsMap[item.__typename] || getHeaderMenuContainerSharedUIComponents(item.__typename, "".concat(item.__typename, "-").concat(index), opened, egCobrandCreditCardWebSwitchBucketed);
    if (SharedUIComponent) {
      return SharedUIComponent;
    }
    var MenuElement = menuFragmentTypes2.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!MenuElement) {
      return null;
    }
    return /* @__PURE__ */React20.createElement(MenuElement, {
      key: "".concat(item.__typename, "-").concat(index),
      data: item
    });
  })))))));
};
HeaderMenu.displayName = "HeaderMenu";
HeaderMenu.fragment = _object_spread_props(_object_spread({}, fragment14), {
  __typename: "HeaderMenu"
});
// src/components/header/__private/__fragments/types/navigation-section-types.tsx
var navigationSectionTypes = [HeaderNavLink, HeaderMenu];
// src/components/header/__private/__fragments/header-section-language-toggle.tsx
var fragment15 = gql18(_templateObject17(), HeaderNavLink.fragment);
var HeaderSectionLanguageToggle = function (props) {
  var _props_data = props.data,
    sectionData = _props_data.sectionData,
    alignment = _props_data.alignment,
    componentsMap = props.componentsMap;
  if (!sectionData) {
    return null;
  }
  return /* @__PURE__ */React21.createElement(UitkLayoutFlexItem7, {
    grow: 1
  }, /* @__PURE__ */React21.createElement(UitkLayoutFlex5, {
    alignItems: "center",
    justifyContent: "end",
    wrap: "nowrap"
  }, sectionData.map(function (item, index) {
    var key = "".concat(item.__typename, "-").concat(index);
    var ToggleElement = navigationSectionTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!ToggleElement) {
      return null;
    }
    return /* @__PURE__ */React21.createElement(ToggleElement, {
      key: key,
      data: item,
      componentsMap: componentsMap
    });
  })));
};
HeaderSectionLanguageToggle.displayName = "HeaderSectionLanguageToggle";
HeaderSectionLanguageToggle.fragment = _object_spread_props(_object_spread({}, fragment15), {
  __typename: "HeaderSection"
});
// src/components/header/__private/__fragments/header-section-logos.tsx
import React23 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
// src/components/header/__private/__fragments/components/header-logo.tsx
import React22 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkHeaderBrandLogo } from "uitk-react-header-brand-logo";
var fragment16 = gql19(_templateObject18());
var HeaderLogo = function (param) {
  var data = param.data;
  var imgSrc = data.imgSrc,
    action = data.action;
  if (!imgSrc.url) {
    return null;
  }
  var url = imgSrc.url,
    description = imgSrc.description;
  return /* @__PURE__ */React22.createElement(UitkHeaderBrandLogo, {
    imgSrc: url,
    href: action.resource.value,
    altText: description
  });
};
HeaderLogo.fragment = _object_spread_props(_object_spread({}, fragment16), {
  __typename: "HeaderLogo"
});
HeaderLogo.displayName = "HeaderLogo";
// src/components/header/__private/__fragments/header-section-logos.tsx
var fragment17 = gql20(_templateObject19(), HeaderLogo.fragment);
var logoSectionTypes = [HeaderLogo];
var HeaderSectionLogos = function (props) {
  var sectionData = props.data.sectionData;
  if (!sectionData) {
    return null;
  }
  return /* @__PURE__ */React23.createElement(React23.Fragment, null, sectionData.map(function (logo, index) {
    var LogoComponent = logoSectionTypes.find(function (type) {
      return type.fragment.__typename === logo.__typename;
    });
    if (!LogoComponent) {
      return null;
    }
    return /* @__PURE__ */React23.createElement(UitkSpacing10, {
      padding: {
        inlineend: "three"
      },
      key: index
    }, /* @__PURE__ */React23.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */React23.createElement(LogoComponent, {
      data: logo
    })));
  }));
};
HeaderSectionLogos.fragment = _object_spread_props(_object_spread({}, fragment17), {
  __typename: "HeaderSection"
});
HeaderSectionLogos.displayName = "HeaderSectionLogos";
// src/components/header/__private/__fragments/header-section-navigation.tsx
import React24 from "react";
import { gql as gql21 } from "@apollo/client";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
var fragment18 = gql21(_templateObject20(), HeaderNavLink.fragment, HeaderMenu.fragment);
var HeaderSectionNavigation = function (props) {
  var _useExperiment3 = useExperiment3("Member_Tier_Celebration_on_Nav_Bar_Web"),
    memberTierCelebrationExposure = _useExperiment3.exposure;
  var _useExperiment31 = useExperiment3("OneKey_BEX_US_Member_Celebration_on_Nav_Bar_Web_"),
    oneKeyBexMemberCelebrationExposure = _useExperiment31.exposure;
  var _useExperiment32 = useExperiment3("BEX_UK_POSa_Member_Celebration_on_Nav_Bar_Web"),
    bexUKMemberCelebrationExposure = _useExperiment32.exposure;
  var omitNavButtonClass = useExperiment3("Shared_UI_Remove_Deprecated_UITK_Nav_Button").exposure.bucket > 0;
  var useMemberProfileStyle = memberTierCelebrationExposure.bucket === 1 || oneKeyBexMemberCelebrationExposure.bucket === 1 || bexUKMemberCelebrationExposure.bucket === 1;
  var _props_data = props.data,
    sectionData = _props_data.sectionData,
    alignment = _props_data.alignment,
    componentsMap = props.componentsMap;
  if (!sectionData) {
    return null;
  }
  var flexMinWidth = useMemberProfileStyle ? "quarter_width" : "half_width";
  if (omitNavButtonClass) {
    flexMinWidth = void 0;
  }
  return /* @__PURE__ */React24.createElement(UitkLayoutFlexItem9, {
    minWidth: flexMinWidth,
    grow: 1
  }, /* @__PURE__ */React24.createElement(UitkSpacing11, {
    padding: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React24.createElement(UitkLayoutFlex6, {
    id: "primary-navigation",
    alignItems: "center",
    justifyContent: alignment === "START" /* START */ ? "start" : "end",
    wrap: "nowrap"
  }, sectionData.map(function (item, index) {
    var NavElement = navigationSectionTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!NavElement) {
      return null;
    }
    return /* @__PURE__ */React24.createElement(NavElement, {
      key: "".concat(item.__typename, "-").concat(index),
      data: item,
      componentsMap: componentsMap
    });
  }))));
};
HeaderSectionNavigation.fragment = _object_spread_props(_object_spread({}, fragment18), {
  __typename: "HeaderSection"
});
HeaderSectionNavigation.displayName = "HeaderSectionNavigation";
// src/components/header/__private/__fragments/header-section-secondary-navigation.tsx
import React25 from "react";
import { gql as gql22 } from "@apollo/client";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
var fragment19 = gql22(_templateObject21(), HeaderNavLink.fragment, HeaderMenu.fragment);
var HeaderSectionSecondaryNavigation = function (props) {
  var _useExperiment4 = useExperiment4("Member_Tier_Celebration_on_Nav_Bar_Web"),
    memberTierCelebrationExposure = _useExperiment4.exposure;
  var _useExperiment41 = useExperiment4("OneKey_BEX_US_Member_Celebration_on_Nav_Bar_Web_"),
    oneKeyBexMemberCelebrationExposure = _useExperiment41.exposure;
  var _useExperiment42 = useExperiment4("BEX_UK_POSa_Member_Celebration_on_Nav_Bar_Web"),
    bexUKMemberCelebrationExposure = _useExperiment42.exposure;
  var omitNavButtonClass = useExperiment4("Shared_UI_Remove_Deprecated_UITK_Nav_Button").exposure.bucket > 0;
  var useMemberProfileStyle = memberTierCelebrationExposure.bucket === 1 || oneKeyBexMemberCelebrationExposure.bucket === 1 || bexUKMemberCelebrationExposure.bucket === 1;
  var _props_data = props.data,
    sectionData = _props_data.sectionData,
    alignment = _props_data.alignment,
    componentsMap = props.componentsMap;
  if (!sectionData) {
    return null;
  }
  var flexMinWidth = useMemberProfileStyle ? "full_width" : "half_width";
  if (omitNavButtonClass) {
    flexMinWidth = void 0;
  }
  return /* @__PURE__ */React25.createElement(UitkLayoutFlexItem10, {
    minWidth: flexMinWidth,
    grow: 1
  }, /* @__PURE__ */React25.createElement(UitkLayoutFlex7, {
    alignItems: "center",
    justifyContent: alignment === "START" /* START */ ? "start" : "end",
    wrap: "nowrap"
  }, sectionData.map(function (item, index) {
    var key = "".concat(item.__typename, "-").concat(index);
    var SharedUIComponent = componentsMap[item.__typename];
    if (SharedUIComponent) {
      return /* @__PURE__ */React25.createElement(React25.Fragment, {
        key: key
      }, SharedUIComponent);
    }
    var NavElement = navigationSectionTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!NavElement) {
      return null;
    }
    return /* @__PURE__ */React25.createElement(NavElement, {
      key: key,
      data: item,
      componentsMap: componentsMap
    });
  })));
};
HeaderSectionSecondaryNavigation.displayName = "HeaderSectionSecondaryNavigation";
HeaderSectionSecondaryNavigation.fragment = _object_spread_props(_object_spread({}, fragment19), {
  __typename: "HeaderSection"
});
// src/components/header/__private/__fragments/sub-header.tsx
import React28 from "react";
import { gql as gql25 } from "@apollo/client";
import { PartnerLoyaltyPoints } from "@shared-ui/retail-global-navigation-partner-loyalty-points";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
// src/components/header/__private/__fragments/components/sub-header-button.tsx
import React26 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize4 } from "uitk-react-button";
var __SubHeaderButtonFragment = gql23(_templateObject22(), HeaderButton.fragment);
var SubHeaderButton = function (param) {
  var data = param.data;
  return /* @__PURE__ */React26.createElement(HeaderButton, {
    data: data,
    size: UitkButtonSize4.SMALL,
    isFullWidth: false
  });
};
SubHeaderButton.displayName = "SubHeaderButton";
SubHeaderButton.fragment = __SubHeaderButtonFragment;
// src/components/header/__private/__fragments/components/sub-header-logo.tsx
import React27 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkHeaderBrandLogo as UitkHeaderBrandLogo2 } from "uitk-react-header-brand-logo";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkText as UitkText4 } from "uitk-react-text";
var __SubHeaderLogoFragment = gql24(_templateObject23());
var SubHeaderLogo = function (props) {
  var data = props.data;
  var text = data.text,
    imgSrc = data.imgSrc,
    action = data.action;
  var useInverseTheme = useInverseThemeContext();
  var href;
  if (action.resource.__typename === "HttpURI") {
    href = action.useRelativePath ? action.resource.relativePath : action.resource.value;
  }
  return /* @__PURE__ */React27.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */React27.createElement(UitkLayoutFlex8, {
    alignItems: "center",
    space: "one"
  }, /* @__PURE__ */React27.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */React27.createElement(UitkText4, _object_spread({
    size: 200,
    weight: "medium",
    whiteSpace: "nowrap"
  }, useInverseTheme && {
    theme: "inverse"
  }), text)), /* @__PURE__ */React27.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */React27.createElement(UitkHeaderBrandLogo2, {
    imgSrc: imgSrc.url,
    href: href,
    altText: imgSrc.description
  }))));
};
SubHeaderLogo.displayName = "SubHeaderLogo";
SubHeaderLogo.fragment = __SubHeaderLogoFragment;
// src/components/header/__private/__fragments/sub-header.tsx
var __SubHeaderFragment = gql25(_templateObject24(), SubHeaderLogo.fragment, SubHeaderButton.fragment);
var SubHeader = function (props) {
  var data = props.data;
  var logo = data.logo,
    text = data.text,
    button = data.button,
    partnerLoyaltyPoints = data.partnerLoyaltyPoints;
  var useInverseTheme = useInverseThemeContext();
  var textAlign = button ? "right" : "center";
  var columns = [logo ? "max-content" : null, text ? "1fr" : null,
  // eslint-disable-next-line no-nested-ternary
  button || partnerLoyaltyPoints ? text ? "max-content" : "1fr" : null].filter(function (value) {
    return value !== null;
  });
  var endColumns = [button ? "max-content" : null, partnerLoyaltyPoints ? "1fr" : null].filter(function (value) {
    return value !== null;
  });
  return /* @__PURE__ */React28.createElement(UitkSpacing12, {
    padding: {
      inline: "six"
    }
  }, /* @__PURE__ */React28.createElement(UitkLayoutGrid, {
    justifyContent: "space-between",
    columns: columns,
    space: "three",
    alignItems: "center"
  }, logo && /* @__PURE__ */React28.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React28.createElement("div", null, logo && /* @__PURE__ */React28.createElement(SubHeaderLogo, {
    data: logo
  }))), text && /* @__PURE__ */React28.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React28.createElement("div", null, /* @__PURE__ */React28.createElement(UitkText5, _object_spread({
    "data-stid": "subheader-text",
    align: textAlign,
    overflow: "truncate-2-lines"
  }, useInverseTheme && {
    theme: "inverse"
  }), text))), (button || partnerLoyaltyPoints) && /* @__PURE__ */React28.createElement(UitkLayoutGridItem, {
    justifySelf: "end"
  }, /* @__PURE__ */React28.createElement("div", null, /* @__PURE__ */React28.createElement(UitkLayoutGrid, {
    columns: endColumns,
    space: "three",
    alignItems: "center"
  }, button && /* @__PURE__ */React28.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React28.createElement("div", null, /* @__PURE__ */React28.createElement(SubHeaderButton, {
    data: button
  }))), partnerLoyaltyPoints && /* @__PURE__ */React28.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React28.createElement("div", null, /* @__PURE__ */React28.createElement(PartnerLoyaltyPoints, {
    inputs: {},
    skipSsr: partnerLoyaltyPoints.skipSsr,
    inverseTheme: useInverseTheme
  }))))))));
};
SubHeader.displayName = "SubHeader";
SubHeader.fragment = __SubHeaderFragment;
// src/components/header/header-fallback.tsx
import React29 from "react";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
import { UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { GlobalNavigationRow, GlobalNavigationSiteHeader as GlobalNavigationSiteHeader2 } from "uitk-react-global-navigation";
import { UitkHeaderBrandLogo as UitkHeaderBrandLogo3 } from "uitk-react-header-brand-logo";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
var HeaderFallback = function (param) {
  var _param_context = param.context,
    siteId = _param_context.siteId,
    locale = _param_context.locale,
    identity = _param_context.identity;
  var isAnonymous = (identity === null || identity === void 0 ? void 0 : identity.authState) === "ANONYMOUS";
  var omitNavButtonClass = useExperiment5("Shared_UI_Remove_Deprecated_UITK_Nav_Button").exposure.bucket > 0;
  return /* @__PURE__ */React29.createElement(GlobalNavigationSiteHeader2, null, /* @__PURE__ */React29.createElement(GlobalNavigationRow, null, /* @__PURE__ */React29.createElement(UitkSpacing13, {
    padding: {
      inlinestart: "six",
      small: {
        inlineend: "three"
      },
      medium: {
        inlineend: "three"
      },
      large: {
        inlineend: "two"
      },
      extra_large: {
        inlineend: "two"
      }
    }
  }, /* @__PURE__ */React29.createElement(UitkLayoutFlex9, null, /* @__PURE__ */React29.createElement(React29.Fragment, null, /* @__PURE__ */React29.createElement(UitkLayoutFlexItem12, {
    grow: 1
  }, /* @__PURE__ */React29.createElement(UitkHeaderBrandLogo3, {
    imgSrc: "/_dms/header/logo.svg?locale=".concat(locale, "&siteid=").concat(siteId),
    href: "/",
    altText: "logo"
  })), /* @__PURE__ */React29.createElement(UitkLayoutFlexItem12, {
    grow: 1
  }, /* @__PURE__ */React29.createElement(UitkLayoutFlex9, {
    justifyContent: "end"
  }, /* @__PURE__ */React29.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */React29.createElement(UitkTertiaryButton3, {
    className: omitNavButtonClass ? void 0 : "global-navigation-nav-button",
    href: isAnonymous ? "/user/signin?ckoflag=0" : "/user/account"
  }, /* @__PURE__ */React29.createElement(UitkIcon4, {
    id: "header-nav-link-account",
    name: "account_circle",
    description: "account"
  }))))))))));
};
HeaderFallback.displayName = "sharedui-HeaderFallback";
// src/components/header/header.tsx
var __HeaderQuery = gql26(_templateObject25(), HeaderSectionLogos.fragment, HeaderSectionNavigation.fragment, HeaderSectionSecondaryNavigation.fragment, HeaderSectionLanguageToggle.fragment, BSABanner.fragment, SubHeader.fragment);
var getViewSize = function (width) {
  switch (true) {
    case width > 1199:
      return "EXTRA_LARGE";
    case width > 991:
      return "LARGE";
    case width > 575:
      return "MEDIUM";
    case width > 0:
      return "SMALL";
    default:
      return null;
  }
};
var viewReducer = function (state, param) {
  var width = param.width,
    serverViewSize = param.serverViewSize;
  var clientViewSize = getViewSize(width);
  var newState = {
    viewSize: clientViewSize,
    calculated: true
  };
  if (newState.viewSize === serverViewSize) {
    return state.calculated === true ? state : _object_spread_props(_object_spread({}, state), {
      calculated: true
    });
  }
  return newState;
};
var Header = function (param) {
  var lineOfBusiness = param.lineOfBusiness,
    layout = param.layout,
    marketing = param.marketing,
    minimal = param.minimal,
    fullWidth = param.fullWidth,
    pageName = param.pageName,
    skipSsr = param.skipSsr;
  var context = useBexApi3().context;
  var _useLogger = useLogger(),
    logWarning = _useLogger.warning,
    logError = _useLogger.error;
  var _React30_useReducer = _sliced_to_array(React30.useReducer(viewReducer, {
      viewSize: null,
      calculated: false
    }), 2),
    viewState = _React30_useReducer[0],
    dispatch = _React30_useReducer[1];
  var theme = useTheme();
  var variables = {
    context: context,
    viewSize: viewState.viewSize,
    lineOfBusiness: lineOfBusiness,
    layout: layout,
    marketing: marketing,
    minimal: minimal !== null && minimal !== void 0 ? minimal : false,
    theme: theme
  };
  var _useQuery = useQuery(__HeaderQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    networkStatus = _useQuery.networkStatus,
    previousData = _useQuery.previousData;
  var windowSize = useWindowSize();
  React30.useEffect(function () {
    if (data) {
      var _data_globalHeader = data.globalHeader,
        serverViewSize = _data_globalHeader.viewSize;
      var clientViewSize = getViewSize(windowSize.width);
      if (viewState.calculated === false && serverViewSize !== clientViewSize) {
        logWarning("HEADER_BAD_VIEWSIZE_GUESS" /* HEADER_BAD_VIEWSIZE_GUESS */, "Bad viewSize server side guess. Client: ".concat(clientViewSize, " Server: ").concat(serverViewSize, " "));
      }
      dispatch({
        width: windowSize.width,
        serverViewSize: serverViewSize
      });
    }
  }, [data, viewState.calculated, logWarning, windowSize]);
  var isSmallViewSize = viewState.viewSize === "SMALL" || !viewState.viewSize && (context.device.type === "APP_PHONE" /* APP_PHONE */ || context.device.type === "MOBILE_PHONE" /* MOBILE_PHONE */);
  var isViewMedium = viewState.viewSize === "MEDIUM" || !viewState.viewSize && (context.device.type === "APP_TABLET" /* APP_TABLET */ || context.device.type === "MOBILE_TABLET" /* MOBILE_TABLET */);
  var ssrSharedUiComponentsMap = {
    HeaderPicker: /* @__PURE__ */React30.createElement(Picker, {
      pickerTriggerPlacementType: isSmallViewSize || isViewMedium ? PickerTriggerPlacementType.MENU_ITEM : PickerTriggerPlacementType.NAV_LINK,
      lineOfBusiness: lineOfBusiness,
      key: "Picker"
    }),
    NotificationCenter: /* @__PURE__ */React30.createElement(Experiment2, {
      name: "NotificationCenter_V1_Web"
    }, /* @__PURE__ */React30.createElement(ExperimentControl2, null), /* @__PURE__ */React30.createElement(ExperimentVariant2, {
      bucket: 1
    }, /* @__PURE__ */React30.createElement(Experiment2, {
      name: "Migrate_Notification_Center_into_Shared_UI_WEB2"
    }, /* @__PURE__ */React30.createElement(ExperimentControl2, null, /* @__PURE__ */React30.createElement(NotificationCenter, {
      inputs: isSmallViewSize ? {
        viewSize: viewState.viewSize,
        lineOfBusiness: lineOfBusiness
      } : {},
      key: "NotificationCenter"
    })), /* @__PURE__ */React30.createElement(ExperimentVariant2, {
      bucket: 1
    })))),
    CommunicationCenter: /* @__PURE__ */React30.createElement(Experiment2, {
      name: "NotificationCenter_V1_Web"
    }, /* @__PURE__ */React30.createElement(ExperimentControl2, null), /* @__PURE__ */React30.createElement(ExperimentVariant2, {
      bucket: 1
    }, /* @__PURE__ */React30.createElement(Experiment2, {
      name: "Migrate_Notification_Center_into_Shared_UI_WEB2"
    }, /* @__PURE__ */React30.createElement(ExperimentControl2, null), /* @__PURE__ */React30.createElement(ExperimentVariant2, {
      bucket: 1
    }, /* @__PURE__ */React30.createElement(Experiment2, {
      name: "CL_conversations_WEB"
    }, /* @__PURE__ */React30.createElement(ExperimentControl2, null, /* @__PURE__ */React30.createElement(CommunicationCenterPreviewMenu, {
      inputs: isSmallViewSize ? {
        viewSize: viewState.viewSize,
        lineOfBusiness: lineOfBusiness
      } : {},
      key: "CommunicationCenter"
    })), /* @__PURE__ */React30.createElement(ExperimentVariant2, {
      bucket: 1
    }, /* @__PURE__ */React30.createElement(CommunicationCenterPreviewMenu, {
      inputs: isSmallViewSize ? {
        viewSize: viewState.viewSize,
        lineOfBusiness: lineOfBusiness
      } : {},
      key: "CommunicationCenter",
      messageCountEnabled: true
    }))))))),
    MobileAppDownloadButton: /* @__PURE__ */React30.createElement(Experiment2, {
      name: "MAD_NavigationBar_test"
    }, /* @__PURE__ */React30.createElement(ExperimentControl2, null), /* @__PURE__ */React30.createElement(ExperimentVariant2, {
      bucket: 1
    }, /* @__PURE__ */React30.createElement(MobileAppDownloadButton, {
      inputs: {
        optionalPageId: pageName
      },
      key: "MobileAppDownloadButton"
    })))
  };
  var externalSharedUiComponentsMap = {
    GoogleOneTap: GoogleOneTap
  };
  var refetching = networkStatus === 4 || networkStatus === 2;
  var mostRecentData = data || previousData;
  if (loading && !refetching || error || !mostRecentData) {
    if (error && context) {
      logError("HEADER_SHOWING_FALLBACK_UI" /* HEADER_SHOWING_FALLBACK_UI */);
      return /* @__PURE__ */React30.createElement(HeaderFallback, {
        context: context
      });
    }
    if (loading && !refetching && typeof window === "undefined") {
      return /* @__PURE__ */React30.createElement(React30.Fragment, null, ssrSharedUiComponentsMap.HeaderPicker, ssrSharedUiComponentsMap.MobileAppDownloadButton, ssrSharedUiComponentsMap.NotificationCenter, ssrSharedUiComponentsMap.CommunicationCenter);
    }
    return null;
  }
  var _mostRecentData_globalHeader = mostRecentData.globalHeader,
    logos = _mostRecentData_globalHeader.logos,
    primaryNavigation = _mostRecentData_globalHeader.primaryNavigation,
    secondaryNavigation = _mostRecentData_globalHeader.secondaryNavigation,
    languageToggle = _mostRecentData_globalHeader.languageToggle,
    bsaBanner = _mostRecentData_globalHeader.bsaBanner,
    subHeader = _mostRecentData_globalHeader.subHeader,
    inverseThemePrimaryRow = _mostRecentData_globalHeader.inverseThemePrimaryRow,
    inverseThemeSecondaryRow = _mostRecentData_globalHeader.inverseThemeSecondaryRow,
    externalSharedUIComponents = _mostRecentData_globalHeader.externalSharedUIComponents;
  var redDotState = mostRecentData === null || mostRecentData === void 0 ? void 0 : mostRecentData.globalHeader.redDotState;
  return /* @__PURE__ */React30.createElement(PageNameContext.Provider, {
    value: pageName || "Unknown"
  }, /* @__PURE__ */React30.createElement(ApolloStateContext.Provider, {
    value: redDotState || "NOT_VISIBLE" /* NOT_VISIBLE */
  }, bsaBanner && /* @__PURE__ */React30.createElement(InverseThemeContext.Provider, {
    value: inverseThemePrimaryRow === true
  }, /* @__PURE__ */React30.createElement(BSABanner, {
    data: bsaBanner
  })), /* @__PURE__ */React30.createElement(GlobalNavigationSiteHeader3, null, /* @__PURE__ */React30.createElement(InverseThemeContext.Provider, {
    value: inverseThemePrimaryRow === true
  }, /* @__PURE__ */React30.createElement(GlobalNavigationRow2, {
    fullWidth: fullWidth || void 0
  }, /* @__PURE__ */React30.createElement(UitkLayoutFlexItem13, {
    grow: 1
  }, /* @__PURE__ */React30.createElement(UitkSpacing14, {
    padding: {
      inlinestart: "six",
      small: {
        inlineend: "three"
      },
      medium: {
        inlineend: "three"
      },
      large: {
        inlineend: "two"
      },
      extra_large: {
        inlineend: "two"
      }
    },
    margin: "unset"
  }, /* @__PURE__ */React30.createElement(UitkLayoutFlex10, {
    wrap: "nowrap",
    alignItems: "center"
  }, logos && /* @__PURE__ */React30.createElement(HeaderSectionLogos, {
    key: "header-logo-".concat(logos.__typename),
    data: logos
  }), primaryNavigation && /* @__PURE__ */React30.createElement(HeaderSectionNavigation, {
    key: "primary-navigation-".concat(primaryNavigation.__typename),
    data: primaryNavigation,
    componentsMap: ssrSharedUiComponentsMap
  }), secondaryNavigation && /* @__PURE__ */React30.createElement(HeaderSectionSecondaryNavigation, {
    key: "secondary-navigation-".concat(secondaryNavigation.__typename),
    data: secondaryNavigation,
    componentsMap: ssrSharedUiComponentsMap
  }), languageToggle && /* @__PURE__ */React30.createElement(HeaderSectionLanguageToggle, {
    key: "language-toggle-".concat(languageToggle.__typename),
    data: languageToggle,
    componentsMap: ssrSharedUiComponentsMap
  })))))), subHeader && /* @__PURE__ */React30.createElement(InverseThemeContext.Provider, {
    value: inverseThemeSecondaryRow === true
  }, /* @__PURE__ */React30.createElement(GlobalNavigationRow2, {
    secondary: true,
    fullWidth: fullWidth || void 0
  }, /* @__PURE__ */React30.createElement(SubHeader, {
    data: subHeader
  }))), externalSharedUIComponents === null || externalSharedUIComponents === void 0 ? void 0 : externalSharedUIComponents.map(function (item, index) {
    var key = "".concat(item.__typename, "-").concat(index);
    var SharedUIComponent = externalSharedUiComponentsMap[item.__typename];
    if (SharedUIComponent) {
      return /* @__PURE__ */React30.createElement(React30.Fragment, {
        key: key
      }, /* @__PURE__ */React30.createElement(SharedUIComponent, {
        skipSsr: item.skipSsr
      }));
    }
    return null;
  }))));
};
Header.displayName = "sharedui-Header";
export { GlobalNavigationLineOfBusiness, Header, HeaderLayout };